import { render, staticRenderFns } from "./leadsDashboardLeadSettings.vue?vue&type=template&id=47896b7e"
import script from "./leadsDashboardLeadSettings.vue?vue&type=script&lang=js"
export * from "./leadsDashboardLeadSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports